export class ShiftAccTypeDayScheduleTabMembership {
	constructor() {}
} 
